import cookie from 'js-cookie';
import { LOCAL_SHOW_SETUP_ACCOUNTS, LOCAL_DIRECT_PATH, SESSION_STORAGE_SESSION_EXPIRED, LOGOUT } from '../constants';
import { clearLocal, getLocalItem, removeTokenCookie, getTokenCookie } from '../utils';
import { callApi } from '../apiCaller';

// authenticate user by passing data to cookie and localstorage during signin
export const authenticate = (response, next = f => f) => {
     const { token, user } = response.data;

     let tokenOptions = { expires: 1 };

     if (window.location.hostname !== 'localhost') {
          tokenOptions.domain = 'listenlayer.com';
     }

     cookie.set('token', token, tokenOptions);
     if (user) {
          localStorage.setItem('user', JSON.stringify(user));
     }
     next();
};

export const authenticateLoginAs = (response, next = f => f) => {
     const { token, user } = response.data;
     let inFiveMinutes = new Date(new Date().getTime() + 5 * 60 * 1000);

     let tokenOptions = { expires: inFiveMinutes };

     if (window.location.hostname !== 'localhost') {
          tokenOptions.domain = 'listenlayer.com';
     }

     cookie.set('token', token, tokenOptions);
     if (user) {
          localStorage.setItem('user', JSON.stringify(user));
     }
     next();
};
// access user info from localstorage
export const isAuth = () => {
     if (typeof window !== 'undefined') {
          const cookieChecked = cookie.get('token');
          if (cookieChecked) {
               return true;
          }
     }
};

export const signout = async (sessionExpired) => {
     const token = getTokenCookie();

     // Call backend to invalidate token (add to blacklist)
     if (token) {
          try {
               await callApi(LOGOUT, 'POST', {}, token);
          } catch (error) {
               // Continue with client-side logout even if API fails
               console.error('Logout API error:', error);
          }
     }

     removeTokenCookie();
     clearLocal();
     localStorage.removeItem(LOCAL_DIRECT_PATH);

     if (sessionExpired === true) {
          sessionStorage.setItem(SESSION_STORAGE_SESSION_EXPIRED, JSON.stringify(true));
     }

     window.location.replace("/login");
};

export const updateUser = (response, next) => {
     if (typeof window !== 'undefined') {
          let auth = JSON.parse(localStorage.getItem('user'));
          auth = response.data.user;
          localStorage.setItem('user', JSON.stringify(auth));
     }
     next();
};

export const handleInvitedUser = (userId) => {
     let localShowSetupAccounts = getLocalItem(LOCAL_SHOW_SETUP_ACCOUNTS);

     if (localShowSetupAccounts?.length > 0) {
          // localShowSetupAccounts must be an array with length > 0
          localShowSetupAccounts.push({ userId, isInvited: 'yes' })
          localStorage.setItem(LOCAL_SHOW_SETUP_ACCOUNTS, JSON.stringify(localShowSetupAccounts));
     } else {
          // localShowSetupAccounts === null || localShowSetupAccounts === []
          localStorage.setItem(LOCAL_SHOW_SETUP_ACCOUNTS, JSON.stringify([{ userId, isInvited: 'yes' }]));
     }
}